import { render, staticRenderFns } from "./CreaNuovoQuestionario.vue?vue&type=template&id=fb9049fe&"
import script from "./CreaNuovoQuestionario.vue?vue&type=script&lang=js&"
export * from "./CreaNuovoQuestionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports